import { render, staticRenderFns } from "./realtime.vue?vue&type=template&id=c234c55c&scoped=true&"
import script from "./realtime.vue?vue&type=script&lang=js&"
export * from "./realtime.vue?vue&type=script&lang=js&"
import style0 from "./realtime.vue?vue&type=style&index=0&id=c234c55c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c234c55c",
  null
  
)

export default component.exports